import {createSlice} from "@reduxjs/toolkit";
import {t} from "i18next";

const initialState = {
  note: null
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setSuccessNotification: (state, action) => {
      state.note = {
        title: t("misc.success"),
        text: action.payload,
        theme: "success"
      };
    },
    setErrorNotification: (state, action) => {
      state.note = {
        title: t("misc.error"),
        text: action.payload,
        theme: "error"
      };
    },
    clearNotification: (state) => {
      state.note = null;
    }
  }
});

export const {setSuccessNotification, setErrorNotification, clearNotification} =
  notificationSlice.actions;

export default notificationSlice.reducer;
